import { PRODUCT_TYPE_LIMITED_TIME_SPECIAL } from 'constants/offer'
import { isBedbankUniqueStaysType, isFlashHotelType } from 'lib/offer/offerTypes'

export interface AccommodationSearchPresentationInput {
  offerType?: App.OfferType
  productType?: App.ProductType
  metadataHidePricing?: boolean
  hideAnytimePrices: boolean
  hasStandardOccupancy: boolean
}

export interface AccommodationSearchActionInput {
  hidePrice: boolean
}

export function shouldHideAccommodationSearchPrice({
  offerType,
  productType,
  metadataHidePricing = false,
  hideAnytimePrices,
  hasStandardOccupancy,
}: AccommodationSearchPresentationInput): boolean {
  if (metadataHidePricing) return true

  const isLimitedTimeSpecialWithStandardOccupancy =
    productType === PRODUCT_TYPE_LIMITED_TIME_SPECIAL && hasStandardOccupancy

  return hideAnytimePrices &&
    !isFlashHotelType(offerType) &&
    !isLimitedTimeSpecialWithStandardOccupancy
}

export type AccommodationSearchPrimaryAction = 'view-offer' | 'select-dates'

export interface AccommodationSearchDateSelectionInput {
  offerType?: App.OfferType
  propertyType?: App.BedbankOffer['propertyType']
  isAnytimeSearch: boolean
  canSelectDates: boolean
}

export function shouldForceAccommodationDateSelection({
  offerType,
  propertyType,
  isAnytimeSearch,
  canSelectDates,
}: AccommodationSearchDateSelectionInput): boolean {
  return canSelectDates && isAnytimeSearch && isBedbankUniqueStaysType(offerType, propertyType)
}

export function getAccommodationSearchPrimaryAction({
  hidePrice,
}: AccommodationSearchActionInput): AccommodationSearchPrimaryAction {
  return hidePrice ? 'select-dates' : 'view-offer'
}
